import { Link, styled } from '@mui/material';

const StyledNavigationLink = styled(Link)(({ theme }) => ({
  // En claro grey[400] casi no se ve sobre la card clara → gris más oscuro; en oscuro se mantiene.
  color: theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[400],
  display: 'block',
  textAlign: 'center'
}));

export default StyledNavigationLink;
